// @ts-nocheck
import { ApiHandler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AddProductApiParameter, addProductWithResult } from "@insite/client-framework/Services/CartService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type AddToCartParameter = {
    onError?: (error: string) => void;
} & AddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter, CartLineModel>;

export const StoreSendDataToApi: HandlerType = async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        /* Store Custom Code - Start */
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });
        /* Store Custom Code - End */

        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, SendDataToApi, StoreSendDataToApi);
